module.exports = __webpack_public_path__ + "img/generator.0daa1de3.svg";